<template>
    <div id="fixedHeader" class="fixed-header">
        <statusBar></statusBar>
        <div class="pages-header">
            <div @click="onNavBack">
                <i class="iconfont icon-xiangzuo"></i>
                <!-- <img class="logo" :src="logoUrl" @click.stop="toHome" /> -->
                <img v-if="device == 'mobile'" class="logo" style="height: .75rem;" :src="logoUrl2" @click.stop="toHome" />
                <img v-else class="logo" :src="logoUrl" @click.stop="toHome" />
            </div>
            <div class="user_action">
                <div></div>
                <div class="user_info">
                    <!-- <div class="CurrencyType"><span>{{ CurrencyType }}</span></div> -->
                    <!-- <div>
                        <div class="user_money">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.balanceAmtAccount ?
                                formatAmount(userInfo.balanceAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                        <div class="user_account">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.bonusAmtAccount ?
                                formatAmount(userInfo.bonusAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                    </div> -->
                    <div class="deposit deposit_app" @click.stop="toDeposit">+</div>
                    <div class="deposit deposit_PC" @click.stop="toDeposit">{{ $t("deposit.Deposit") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
import { mapState } from 'vuex'
export default {
    name: 'gameHeader',
    components: { statusBar },
    data() {
        return {}
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        }
    },
    created() { },
    methods: {
        onNavBack() {
            this.$emit('onNavBack')
        },
        toHome() {
            this.$emit('toHome')
        },
        toDeposit() {
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    box-shadow: 0 4px 20px rgba(4, 16, 34, .28);
    background:
        linear-gradient(180deg, rgba(37, 97, 177, .28) 0%, rgba(37, 97, 177, 0) .2rem),
        linear-gradient(90deg, rgba(17, 58, 117, .98) 0%, rgba(11, 39, 84, .98) 46%, rgba(9, 30, 62, .99) 100%);

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        padding-right: .2rem;
        height: 1rem;
        padding-right: .2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;

        &>div:first-child {
            display: flex;
            align-items: center;
            padding-left: .2rem;
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 3;

            &>i {
                color: #ffffff;
                font-size: .48rem;
                margin-right: .14rem;
            }

            .logo {
                height: .48rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            .user_info {
                display: flex;
                align-items: center;
                // column-gap: 10px;
                font-size: .24rem;
                background: linear-gradient(180deg, rgba(18, 53, 105, .96) 0%, rgba(11, 36, 74, .98) 100%);
                border: 1px solid rgba(255,255,0, .24);
                // padding: .01rem .15rem;
                // padding-right: .08rem;
                border-radius: .1rem;

                .CurrencyType {
                    background: rgba(24, 171, 125, 1);
                    padding: .02rem;
                    border-radius: 50%;
                    flex-shrink: 0;
                    width: .36rem;
                    height: .36rem;
                    text-align: center;
                    line-height: .36rem;
                    color: #fff;
                    font-size: .23rem;
                }

                .user_account,
                .user_money {
                    // display: flex;
                    // align-items: center;
                    color: #FFFFFF;
                    // background: rgba(255, 255, 255, 0.15);
                    padding: 0 .08rem;
                    border-radius: .2rem;
                }

                .user_account {
                    color: #afc2e4;
                }

                .icon-shuaxin {
                    font-size: .2rem;
                    color: #ffd24a;
                }

                .deposit {
                    height: .6rem;
                    border-radius: .17rem;
                    background:
                        linear-gradient(180deg, rgba(243, 252, 255, .22) 0%, rgba(243, 252, 255, .08) 24%, rgba(243, 252, 255, 0) 25%),
                        linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%);
                    color: #f8fcff;
                    box-shadow: inset 0 1px 0 rgba(243, 252, 255, .24), 0 .08rem .16rem rgba(4, 16, 34, .18);
                    line-height: .6rem;
                    font-size: .5rem;
                    // margin-left: .1rem;

                    &.deposit_app {
                        display: none;
                        width: .6rem;
                    }

                    &.deposit_PC {
                        font-size: .25rem;
                        font-weight: bold;
                        padding: 0 .3rem;
                        text-transform: uppercase;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-header {
        z-index: 100;

        .downApp {
            display: none;
        }
    }
}

.fixed-header {
    .pages-header {
        & > div:first-child > i {
            color: #fff7e9;
        }
    }
}
</style>
